module.exports = __webpack_public_path__ + "media/12_17.3a7f07b3.wav";